import { QueryObserverOptions } from "@tanstack/react-query"

import { EditSideMenuRequest, EditTableSettingRequest } from "@shared/dtos/requests/settingsRequests.dto"
import { SettingsResponse } from "@shared/dtos/responses/settingsResponses.dto"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

// Sets defaults used in `buildApiFromServices`
export const queryOptions: Partial<QueryObserverOptions> = {
  staleTime: 5 * 60 * 1000, // 5 minutes
  refetchOnMount: false,
}

export const get = (): Promise<SettingsResponse> => {
  return axiosAuth({
    url: "/settings",
    method: "get",
  }).then((resp) => resp.data)
}

export const editSideMenu = (req: EditSideMenuRequest): Promise<void> => {
  return axiosAuth({
    url: "/settings/sidemenu",
    method: "put",
    data: req,
  }).then(() => undefined)
}

export const editTableSettings = (req: EditTableSettingRequest): Promise<void> => {
  return axiosAuth({
    url: "/settings/table",
    method: "patch",
    data: req,
  }).then(() => undefined)
}
